import { Action, ActionType } from './action';
import { UpsellState, initialState } from './state';

export const reducer = (state: UpsellState = initialState, action: Action): UpsellState => {
  switch (action.type) {
    case ActionType.SetIsModalOpen: {
      return {
        ...state,
        isModalOpen: action.payload,
      };
    }
    case ActionType.SetMarket: {
      return {
        ...state,
        market: action.payload,
      };
    }
    case ActionType.SetNotificationMessage: {
      return {
        ...state,
        notification: action.payload,
      };
    }
    case ActionType.SetActiveSlideIndex: {
      return {
        ...state,
        activeSlideIndex: action.payload,
      };
    }
    case ActionType.SetSingleSlide: {
      return {
        ...state,
        singleSlide: action.payload,
      };
    }
    case ActionType.SetPageName: {
      return {
        ...state,
        pageName: action.payload,
      };
    }
    case ActionType.SetBannerNumber: {
      return {
        ...state,
        bannerNumber: action.payload,
      };
    }
    case ActionType.SetRetailKADUpsellMessage: {
      return {
        ...state,
        retailKADUpsellMessage: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
